/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardSubHeader }}</p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationname">
                    {{cvNameLabel}}</label
                  >
                  <input
                    v-model="vmGPathCareerFormData.name"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle1">
                    {{cvTitle1Label}}</label
                  >
                  <input
                    v-model="vmGPathCareerFormData.title1"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                    <label for="validationtitle2">
                      {{cvTitle2Label}}</label
                    >
                    <input
                      v-model="vmGPathCareerFormData.title2"
                      type="text"
                      class="form-control"
                      required
                    />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationdescription">
                    {{cvDescriptionLabel}}</label>
                  <textarea
                    v-model="vmGPathCareerFormData.description"
                    type="text"
                    class="form-control textarea"
                    required>
                  </textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationimage">
                    {{cvImageLabel}}</label
                  >
                  <input
                    v-model="vmGPathCareerFormData.image"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationcolor_code">
                    {{cvColorCodeLabel}}</label
                  >
                  <input
                    v-model="vmGPathCareerFormData.color_code"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                    <b-spinner label="Spinning"></b-spinner>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="gpath_careerAdd()"
                >
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { GPathCareers } from "../../../FackApi/api/GPathCareer"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "GPathCareerAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      apiName: "gpath_careers_inter_add",
      cvCardTitle: "Add GPaths Career",
      cvCardSubHeader: "Add GPaths Career ",
      cvSubmitBtn: "Add",
      cvNameLabel: "name",
      cvTitle1Label: "title1",
      cvTitle2Label: "title2",
      cvDescriptionLabel: "description",
      cvImageLabel: "image",
      cvColorCodeLabel: "color code",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "GPaths Career Add",
      vmGPathCareerFormData: Object.assign({}, this.initFormData()),
      vmGPathCareerDesc: null,
      vmGPathCareerType: null
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "name": "",
        "title1": "",
        "title2": "",
        "description": "",
        "image": "",
        "color_code": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmGPathCareerFormData) {
          if (!this.vmGPathCareerFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * gpath_careerAdd
     */
    async gpath_careerAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true
        let gpathCareerAddResp = await GPathCareers.gpath_careerAdd(this, this.vmGPathCareerFormData)
        await ApiResponse.responseMessageDisplay(this, gpathCareerAddResp)
        if (gpathCareerAddResp && !gpathCareerAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGPathCareerAddModal", gpathCareerAddResp.resp_data)
        }
        this.vmGPathCareerFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at gpath_careerAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
